export default [
    {
        path: '/providers',
        name: 'Providers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Providers',
        },
        components: {
            default: () => import('@views/providers/ProvidersIndex.vue'),
        },
    },
    {
        path: '/providers/create',
        name: 'ProvidersCreate',
        props: {
            default: () => ({ isCreate: true }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create provider',
        },
        components: {
            default: () => import('@views/providers/ProvidersForm.vue'),
        },
    },
    {
        path: '/providers/:id/edit',
        name: 'ProvidersEdit',
        props: {
            default: (route) => ({ id: route.params.id, isCreate: false }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit provider',
        },
        components: {
            default: () => import('@views/providers/ProvidersForm.vue'),
        },
    },
    {
        path: '/providers/:id/view',
        name: 'ProvidersView',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'View provider',
        },
        components: {
            default: () => import('@views/providers/ProvidersView.vue'),
        },
    },
];
